module.exports = __webpack_public_path__ + "static/media/8.Varities of Spray Guns.7e4a2c53.jpg";